import React from 'react';
import { ApButtonLink } from '@alixpartners/ui-components';

import {
  ContentBlock,
  CostLabel,
  CostValue,
  Description,
  RightSection,
  RightSectionColumn,
  SectionWrapper,
  Title,
} from '../../EnvironmentSetup/EnvironmentSetup.styles';
import CodeSnippet from '../../../../components/CodeSnippet';

interface IProps {
  dataFactoryUrl: string;
  dataFactoryName: string;
}

export const DataFactorySection = ({
  dataFactoryUrl,
  dataFactoryName,
}: IProps) => {
  return (
    <SectionWrapper animationIndex={5}>
      <Title>Azure Data Factory</Title>
      <ContentBlock>
        <Description>
          Your Data Factory can be found here, lots of useful guides to get you
          started
        </Description>
        <RightSection>
          <RightSectionColumn>
            <CostLabel>Data Factory name</CostLabel>
            <CodeSnippet>{dataFactoryName}</CodeSnippet>
          </RightSectionColumn>

          <RightSectionColumn>
            <CostValue>
              <ApButtonLink
                target="_blank"
                href={dataFactoryUrl}
                rel="noopener noreferrer"
              >
                Azure Data Factory link
              </ApButtonLink>
            </CostValue>
          </RightSectionColumn>
          <RightSectionColumn />
        </RightSection>
      </ContentBlock>
    </SectionWrapper>
  );
};
